export default __webpack_public_path__ + "static/media/icon-id-card.733f5280.svg";